import React, { useEffect } from 'react'
import { Box } from '@mui/system'
import Sidebar from './sidebar'
import { Button } from '@mui/material';

import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import CustomToolbar from './CustomToolbarPrint';
import "../App.css"


import { doc, addDoc, collection, query, getDocs, deleteDoc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase.js";

import { darken, lighten } from '@mui/material/styles';


const getBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

const getHoverBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);





export default function Home() {
  // const [rows, setRows] = React.useState([])

  // let arr = [];
  // let expiry = []


  // useEffect(() => {
  //   test()

  //   async function test() {
  //     arr = []
  //     expiry = []
  //     getData()
  //   }
  //   function compare(a, b) {
  //     console.log(b)
  //     if (a.days > b.days) return 1;
  //     if (b.days > a.days) return -1;
    
  //     return 0;
  //   }
    
  //  expiry.sort(compare);    

  //   setRows(expiry)
  //   console.log(rows)

  // }, []);


  // async function getData() {

  //   let arr = []
  //   let expiry = []

  //   const q = query(collection(db, "employee"));
  //   const querySnapshot = await getDocs(q);
  //   querySnapshot.forEach((doc) => {
  //     let obj = doc.data();
  //     Object.assign(obj, { doc: doc.id });
  //     // console.log(obj)
  //     obj.qualification.forEach((e) => {

  //       let d1 = new Date(e.date);
  //       let today = new Date();
  //       let difference = d1 - today;
  //       let days = Math.round(difference / (1000 * 60 * 60 * 24));

  //       let pass;
  //       if (days <= 7) {
  //         pass = {
  //           color: "red-data-grid",
  //           data: obj,
  //           name: e.qualification,
  //           date: e.date,
  //           dname: obj.firstName,
  //           days: days,
  //           id: Date.now() * Math.random()

  //         }
  //       } else if (days <= 30) {
  //         pass = {
  //           color: "orange-data-grid",
  //           data: obj,
  //           name: e.qualification,
  //           date: e.date,
  //           dname: obj.firstName,
  //           days: days,
  //           id: Date.now() * Math.random()

  //         }
  //       } else if (days <= 60) {
  //         pass = {
  //           color: "green-data-grid",
  //           data: obj,
  //           name: e.qualification,
  //           date: e.date,
  //           dname: obj.firstName,
  //           days: days,
  //           id: Date.now() * Math.random()

  //         }
  //       }
  //       if (pass != undefined) {
  //         expiry.push(pass);
  //       }

  //     })

  //     obj.training.forEach((e) => {

  //       let d1 = new Date(e.date);
  //       let today = new Date();
  //       let difference = d1 - today;
  //       let days = Math.round(difference / (1000 * 60 * 60 * 24));

  //       let pass;
  //       if (days <= 7) {
  //         pass = {
  //           color: "red-data-grid",
  //           data: obj,
  //           name: e.training,
  //           date: e.date,
  //           dname: obj.firstName,
  //           days: days,
  //           id: Date.now() * Math.random()

  //         }
  //       } else if (days <= 30) {
  //         pass = {
  //           color: "orange-data-grid",
  //           data: obj,
  //           name: e.training,
  //           date: e.date,
  //           dname: obj.firstName,
  //           days: days,
  //           id: Date.now() * Math.random()

  //         }
  //       } else if (days <= 60) {
  //         pass = {
  //           color: "green-data-grid",
  //           data: obj,
  //           name: e.training,
  //           date: e.date,
  //           dname: obj.firstName,
  //           days: days,
  //           id: Date.now() * Math.random()

  //         }

  //       }
  //       if (pass != undefined) {
  //         expiry.push(pass);
  //       }

  //     })


  //     arr.push(obj)
  //   });
  //   console.log(expiry)
  //   function compare(a, b) {
  //     if (a.days > b.days) return 1;
  //     if (b.days > a.days) return -1;
    
  //     return 0;
  //   }
    
  //  expiry.sort(compare);   
  //   setRows(expiry)

  // }



  const navigate = useNavigate();
 
  

  return (



    <Box sx={{ display: 'flex' }}>
      <Sidebar />

      <div style={{ height: 625, width: '80%', display: "flex", alignItems: "flex-end", flexDirection: "column"}}>
      
      <Button onClick={() => navigate("/services")} className='addform' variant="contained" style={{ width: "25%", height: "50px", marginTop: "30px", backgroundColor: "#F21D2F" }}>Services Provided By Date</Button>
      <Button onClick={() => navigate("/activityLogViewer")} className='addform' variant="contained" style={{ width: "25%", height: "50px", marginTop: "30px", backgroundColor: "#F21D2F" }}>View Activity Logs</Button>
      <Button onClick={() => navigate("/currentlyinRehab")} className='addform' variant="contained" style={{ width: "25%", height: "50px", marginTop: "30px", backgroundColor: "#F21D2F" }}>Currently in Rehab</Button>
      {/* <Button  className='addform' variant="contained" style={{ width: "25%", height: "50px", marginTop: "30px", backgroundColor: "#F21D2F" }}>Report 3</Button> */}
      </div>
      


    </Box>


  )
}
